

import { Link } from '@mui/material';
import { RouterLink } from '../../routes/components';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

const Logo = ()=> {
  const logo_url  = useSelector((state)=> state.LoginReducer && state.LoginReducer.data && state.LoginReducer.data.logo && state.LoginReducer.data.logo !== null && state.LoginReducer.data.logo !== undefined && state.LoginReducer.data.logo !== "" ? state.LoginReducer.data.logo  : null ) 
  return (
    <Link component={RouterLink} href="/" sx={{ marginLeft:"30px", marginTop:"14px" }}  >
      {/*<img src='https://dealkarts.in/images/navlogo.png' width="60px" height='60px' />*/}
      {
        logo_url ? 
        <img src={logo_url} width="60px" height='60px' /> :
        <img src='.\assets\OES_LOGO.PNG' width="60px" height='60px' style={{borderRadius:'10%'}} />
      }
      
      
    </Link>
  );
};

export default Logo;
